import Immutable from 'immutable';

const StudyPlanRecord = Immutable.Record({
  studentIDPId: undefined,
  studyPlanId: undefined,
  coreCourseId: undefined,
  nonCoreCourseId: undefined,
  otherOptions: undefined,
  sequence: undefined,
});

export default class StudyPlan extends StudyPlanRecord { }



// WEBPACK FOOTER //
// ./data/IndividualDevelopmentPlans/StudyPlan/result/model.js